import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'emm-add-modifier-image-dialog',
    templateUrl: './preview-image-dialog.component.html',
    styleUrls: ['./preview-image-dialog.component.scss'],
    standalone: false
})
export class PreviewImageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PreviewImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
